//import {h} from 'preact';
import React from 'react';
import styles from './styles.css';
import {observer, inject} from 'mobx-react';
import { Link } from 'react-toolbox/lib/link';

function AppFooter({view}) {
  return (
    <footer className={styles.footer}>
      <br/>
      <div>Made with ♥ by <a className={styles.link} href="https://github.com/dev357" target="_blank">dev357</a></div>
      <div>view.loggingIn: {JSON.stringify(view.loggingIn)}</div>
    </footer>
  );
}

export default inject('view')(observer(AppFooter));



// WEBPACK FOOTER //
// ./src/components/AppFooter/AppFooter.js